var map = {
	"./alert-circle/16.svg": [
		60885,
		1334
	],
	"./alert-circle/24.svg": [
		78874,
		473
	],
	"./bullet/16.svg": [
		53432,
		595
	],
	"./bullet/24.svg": [
		89703,
		3948
	],
	"./burger-menu/16.svg": [
		66343,
		1080
	],
	"./burger-menu/24.svg": [
		26252,
		7675
	],
	"./checkmark-circle/16.svg": [
		5484,
		1959
	],
	"./checkmark-circle/24.svg": [
		58795,
		176
	],
	"./credit-card/16.svg": [
		94518,
		2441
	],
	"./credit-card/24.svg": [
		85181,
		2858
	],
	"./drag-drop-horizontal/16.svg": [
		1087,
		5920
	],
	"./drag-drop-horizontal/24.svg": [
		21636,
		4531
	],
	"./drag-drop-vertical/16.svg": [
		4649,
		8074
	],
	"./drag-drop-vertical/24.svg": [
		21806,
		2749
	],
	"./files/file-download/16.svg": [
		97705,
		8900
	],
	"./files/file-download/24.svg": [
		12750,
		9175
	],
	"./files/file-import/16.svg": [
		88008,
		7837
	],
	"./files/file-import/24.svg": [
		36407,
		4446
	],
	"./files/file-script/16.svg": [
		41810,
		2763
	],
	"./files/file-script/24.svg": [
		40489,
		1940
	],
	"./files/pdf/16.svg": [
		86566,
		8955
	],
	"./files/pdf/24.svg": [
		61645,
		6932
	],
	"./files/text-file/16.svg": [
		59536,
		573
	],
	"./files/text-file/24.svg": [
		72735,
		2750
	],
	"./general/ai-detector/16.svg": [
		36180,
		2389
	],
	"./general/ai-detector/24.svg": [
		21811,
		1702
	],
	"./general/ai-search/16.svg": [
		37770,
		3611
	],
	"./general/ai-search/24.svg": [
		33953,
		5556
	],
	"./general/ai/16.svg": [
		47375,
		8502
	],
	"./general/ai/24.svg": [
		82772,
		3849
	],
	"./general/arrow-turn-forward/16.svg": [
		40030,
		8363
	],
	"./general/arrow-turn-forward/24.svg": [
		60389,
		1076
	],
	"./general/brush/16.svg": [
		11563,
		770
	],
	"./general/brush/24.svg": [
		99376,
		933
	],
	"./general/bubble-chat/16.svg": [
		43944,
		1781
	],
	"./general/bubble-chat/24.svg": [
		14743,
		1094
	],
	"./general/calendar/16.svg": [
		14619,
		2822
	],
	"./general/calendar/24.svg": [
		79136,
		8169
	],
	"./general/check-double/16.svg": [
		54863,
		6786
	],
	"./general/check-double/24.svg": [
		90260,
		2149
	],
	"./general/check-list/16.svg": [
		20526,
		6455
	],
	"./general/check-list/24.svg": [
		22517,
		9904
	],
	"./general/check/16.svg": [
		93047,
		5006
	],
	"./general/check/24.svg": [
		31164,
		3009
	],
	"./general/chrome/16.svg": [
		5255,
		6738
	],
	"./general/chrome/24.svg": [
		48812,
		5749
	],
	"./general/citation/16.svg": [
		69348,
		4521
	],
	"./general/citation/24.svg": [
		6563,
		2266
	],
	"./general/copy/16.svg": [
		94168,
		4553
	],
	"./general/copy/24.svg": [
		30439,
		5578
	],
	"./general/delete/16.svg": [
		35502,
		1655
	],
	"./general/delete/24.svg": [
		53845,
		480
	],
	"./general/download/16.svg": [
		15337,
		784
	],
	"./general/download/24.svg": [
		30382,
		9395
	],
	"./general/edit/16.svg": [
		15137,
		9944
	],
	"./general/edit/24.svg": [
		3718,
		6427
	],
	"./general/filter/16.svg": [
		20111,
		5310
	],
	"./general/filter/24.svg": [
		55508,
		3825
	],
	"./general/flashcards/16.svg": [
		22360,
		4530
	],
	"./general/flashcards/24.svg": [
		42279,
		4214
	],
	"./general/help-circle/16.svg": [
		94233,
		320
	],
	"./general/help-circle/24.svg": [
		62398,
		9475
	],
	"./general/highlight/16.svg": [
		97051,
		5086
	],
	"./general/highlight/24.svg": [
		92192,
		6337
	],
	"./general/history/16.svg": [
		27079,
		54
	],
	"./general/history/24.svg": [
		40012,
		5897
	],
	"./general/home/16.svg": [
		54726,
		2675
	],
	"./general/home/24.svg": [
		29805,
		8348
	],
	"./general/humanize/16.svg": [
		57232,
		729
	],
	"./general/humanize/24.svg": [
		70431,
		1562
	],
	"./general/idea/16.svg": [
		9102,
		3031
	],
	"./general/idea/24.svg": [
		99701,
		1856
	],
	"./general/image/16.svg": [
		51894,
		1543
	],
	"./general/image/24.svg": [
		7357,
		9760
	],
	"./general/information-circle/16.svg": [
		96996,
		6225
	],
	"./general/information-circle/24.svg": [
		34211,
		2866
	],
	"./general/learn/16.svg": [
		88393,
		1844
	],
	"./general/learn/24.svg": [
		29614,
		2087
	],
	"./general/link/16.svg": [
		57393,
		1984
	],
	"./general/link/24.svg": [
		54806,
		1955
	],
	"./general/lock/16.svg": [
		50594,
		447
	],
	"./general/lock/24.svg": [
		64409,
		40
	],
	"./general/note-edit/16.svg": [
		47708,
		2633
	],
	"./general/note-edit/24.svg": [
		18907,
		1818
	],
	"./general/paperclip/16.svg": [
		82632,
		2862
	],
	"./general/paperclip/24.svg": [
		27104,
		6113
	],
	"./general/personal info/16.svg": [
		72235,
		6033
	],
	"./general/personal info/24.svg": [
		60048,
		7410
	],
	"./general/placeholder/16.svg": [
		84214,
		7975
	],
	"./general/placeholder/24.svg": [
		66973,
		6800
	],
	"./general/plagiarism/16.svg": [
		56522,
		4199
	],
	"./general/plagiarism/24.svg": [
		69057,
		2416
	],
	"./general/plus-circle/16.svg": [
		93508,
		3553
	],
	"./general/plus-circle/24.svg": [
		9763,
		9570
	],
	"./general/plus-sign/16.svg": [
		73917,
		3536
	],
	"./general/plus-sign/24.svg": [
		35010,
		2147
	],
	"./general/profile/16.svg": [
		49066,
		4563
	],
	"./general/profile/24.svg": [
		61601,
		3532
	],
	"./general/quill-write/16.svg": [
		98120,
		197
	],
	"./general/quill-write/24.svg": [
		30167,
		5270
	],
	"./general/quiz/16.svg": [
		58644,
		8617
	],
	"./general/quiz/24.svg": [
		70675,
		602
	],
	"./general/references/16.svg": [
		19723,
		9994
	],
	"./general/references/24.svg": [
		84016,
		4669
	],
	"./general/refresh/16.svg": [
		50420,
		8793
	],
	"./general/refresh/24.svg": [
		9427,
		4330
	],
	"./general/reprism-chat/16.svg": [
		25570,
		3475
	],
	"./general/reprism-chat/24.svg": [
		62681,
		9148
	],
	"./general/search/16.svg": [
		46261,
		624
	],
	"./general/search/24.svg": [
		38074,
		1987
	],
	"./general/send-arrow-up/16.svg": [
		60123,
		5510
	],
	"./general/send-arrow-up/24.svg": [
		40992,
		4649
	],
	"./general/settings/16.svg": [
		63844,
		5925
	],
	"./general/settings/24.svg": [
		80099,
		2166
	],
	"./general/spinner-loader/16.svg": [
		89050,
		7683
	],
	"./general/spinner-loader/24.svg": [
		99025,
		8188
	],
	"./general/summary/16.svg": [
		57423,
		7010
	],
	"./general/summary/24.svg": [
		52564,
		5909
	],
	"./general/text/16.svg": [
		81938,
		1459
	],
	"./general/text/24.svg": [
		95337,
		2492
	],
	"./general/thumbs-down-filled/16.svg": [
		60322,
		8011
	],
	"./general/thumbs-down/16.svg": [
		34203,
		1826
	],
	"./general/thumbs-down/24.svg": [
		17408,
		1989
	],
	"./general/thumbs-up-filled/16.svg": [
		50813,
		3880
	],
	"./general/thumbs-up/16.svg": [
		29778,
		5871
	],
	"./general/thumbs-up/24.svg": [
		85705,
		5960
	],
	"./general/tokens/16.svg": [
		17507,
		498
	],
	"./general/tokens/24.svg": [
		67304,
		6245
	],
	"./general/undo/16.svg": [
		62847,
		5526
	],
	"./general/undo/24.svg": [
		46660,
		8313
	],
	"./general/unlock/16.svg": [
		85773,
		6452
	],
	"./general/unlock/24.svg": [
		31794,
		1895
	],
	"./general/upgrade/16.svg": [
		4075,
		9998
	],
	"./general/upgrade/24.svg": [
		68592,
		8513
	],
	"./general/upload/16.svg": [
		52724,
		305
	],
	"./general/upload/24.svg": [
		11731,
		9122
	],
	"./general/verified/16.svg": [
		8641,
		900
	],
	"./general/verified/24.svg": [
		4550,
		9079
	],
	"./general/view-off/16.svg": [
		64364,
		1889
	],
	"./general/view-off/24.svg": [
		17675,
		3266
	],
	"./general/view/16.svg": [
		97100,
		7013
	],
	"./general/view/24.svg": [
		27115,
		8854
	],
	"./general/word-count/16.svg": [
		58343,
		2902
	],
	"./general/word-count/24.svg": [
		88684,
		8745
	],
	"./general/write/16.svg": [
		9396,
		3569
	],
	"./general/write/24.svg": [
		68403,
		8738
	],
	"./globe/16.svg": [
		36485,
		5094
	],
	"./globe/24.svg": [
		27658,
		3081
	],
	"./image-caption/16.svg": [
		2578,
		2181
	],
	"./image-caption/24.svg": [
		1257,
		2118
	],
	"./link-square/16.svg": [
		15888,
		7403
	],
	"./link-square/24.svg": [
		47935,
		116
	],
	"./navigation/arrow-down/16.svg": [
		27767,
		6326
	],
	"./navigation/arrow-down/24.svg": [
		22908,
		2313
	],
	"./navigation/arrow-left/16.svg": [
		59470,
		5735
	],
	"./navigation/arrow-left/24.svg": [
		61461,
		7088
	],
	"./navigation/arrow-right/16.svg": [
		20847,
		5054
	],
	"./navigation/arrow-right/24.svg": [
		56244,
		6305
	],
	"./navigation/arrow-up-left/16.svg": [
		40452,
		7249
	],
	"./navigation/arrow-up-left/24.svg": [
		56707,
		9314
	],
	"./navigation/arrow-up-right/16.svg": [
		94229,
		3920
	],
	"./navigation/arrow-up-right/24.svg": [
		28570,
		2531
	],
	"./navigation/arrow-up/16.svg": [
		45302,
		4411
	],
	"./navigation/arrow-up/24.svg": [
		35965,
		7124
	],
	"./navigation/chevron-down/16.svg": [
		78337,
		5164
	],
	"./navigation/chevron-down/24.svg": [
		50566,
		6655
	],
	"./navigation/chevron-left/16.svg": [
		80600,
		1045
	],
	"./navigation/chevron-left/24.svg": [
		519,
		358
	],
	"./navigation/chevron-right/16.svg": [
		98382,
		9356
	],
	"./navigation/chevron-right/24.svg": [
		48230,
		8175
	],
	"./navigation/chevron-up/16.svg": [
		38964,
		7909
	],
	"./navigation/chevron-up/24.svg": [
		97971,
		4198
	],
	"./navigation/chevrons-left/16.svg": [
		34987,
		254
	],
	"./navigation/chevrons-left/24.svg": [
		87376,
		4657
	],
	"./navigation/chevrons-right/16.svg": [
		71136,
		4965
	],
	"./navigation/chevrons-right/24.svg": [
		60335,
		4278
	],
	"./navigation/close/16.svg": [
		73809,
		6564
	],
	"./navigation/close/24.svg": [
		54870,
		4743
	],
	"./navigation/left-panel/16.svg": [
		36053,
		4216
	],
	"./navigation/left-panel/24.svg": [
		27866,
		5563
	],
	"./navigation/log-in/16.svg": [
		93017,
		4224
	],
	"./navigation/log-in/24.svg": [
		77534,
		4963
	],
	"./navigation/log-out/16.svg": [
		19810,
		919
	],
	"./navigation/log-out/24.svg": [
		49977,
		2272
	],
	"./navigation/maximize/16.svg": [
		15429,
		4172
	],
	"./navigation/maximize/24.svg": [
		79754,
		1951
	],
	"./navigation/minimize/16.svg": [
		52539,
		9606
	],
	"./navigation/minimize/24.svg": [
		17056,
		6041
	],
	"./navigation/more-horizontal/16.svg": [
		63133,
		8816
	],
	"./navigation/more-horizontal/24.svg": [
		10434,
		8787
	],
	"./navigation/more-horizontal_oval/16.svg": [
		52286,
		387
	],
	"./navigation/more-horizontal_oval/24.svg": [
		78917,
		6060
	],
	"./rephrase/16.svg": [
		98788,
		2031
	],
	"./rephrase/24.svg": [
		36003,
		9560
	],
	"./star-filled/16.svg": [
		34815,
		3232
	],
	"./star-filled/24.svg": [
		18628,
		4595
	],
	"./star/16.svg": [
		91084,
		9735
	],
	"./star/24.svg": [
		44395,
		9536
	],
	"./stop/16.svg": [
		36524,
		679
	],
	"./stop/24.svg": [
		66539,
		9504
	],
	"./table-header/16.svg": [
		19558,
		5993
	],
	"./table-header/24.svg": [
		69229,
		4298
	],
	"./text-editor/bold/16.svg": [
		93887,
		4042
	],
	"./text-editor/bold/24.svg": [
		35172,
		6925
	],
	"./text-editor/bullet-list/16.svg": [
		67023,
		3230
	],
	"./text-editor/bullet-list/24.svg": [
		2420,
		4481
	],
	"./text-editor/equation/16.svg": [
		52822,
		2883
	],
	"./text-editor/equation/24.svg": [
		43485,
		3916
	],
	"./text-editor/h1/16.svg": [
		29935,
		3810
	],
	"./text-editor/h1/24.svg": [
		5844,
		9557
	],
	"./text-editor/h2/16.svg": [
		95802,
		9259
	],
	"./text-editor/h2/24.svg": [
		52753,
		7236
	],
	"./text-editor/h3/16.svg": [
		89617,
		3584
	],
	"./text-editor/h3/24.svg": [
		38550,
		2195
	],
	"./text-editor/h4/16.svg": [
		23524,
		5473
	],
	"./text-editor/h4/24.svg": [
		7715,
		8466
	],
	"./text-editor/h5/16.svg": [
		40371,
		8262
	],
	"./text-editor/h5/24.svg": [
		13464,
		7257
	],
	"./text-editor/italic/16.svg": [
		4724,
		6949
	],
	"./text-editor/italic/24.svg": [
		33107,
		9014
	],
	"./text-editor/numbered-list/16.svg": [
		74135,
		2214
	],
	"./text-editor/numbered-list/24.svg": [
		95900,
		8057
	],
	"./text-editor/table/16.svg": [
		56580,
		3937
	],
	"./text-editor/table/24.svg": [
		72835,
		7842
	],
	"./text-editor/text/16.svg": [
		52251,
		7046
	],
	"./text-editor/text/24.svg": [
		16768,
		8422
	],
	"./text-editor/underline/16.svg": [
		58196,
		1305
	],
	"./text-editor/underline/24.svg": [
		86579,
		3290
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 70778;
module.exports = webpackAsyncContext;